import React__default from 'react';
import { Logo as Logo$1 } from '@sravni/react-design-system/lib/Logo';
import { useStyles } from '@sravni/react-utils';
import { decorateRelativeUrlByDomain } from '../../../utils/links.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_997b7aad from '../styles/Logo.module.less.js';

const Logo = (props) => {
    const { className, ...rest } = props;
    const { domains } = useCustomProps();
    const cx = useStyles(modules_997b7aad);
    return (React__default.createElement("a", { "data-element": "logo-link", href: domains?.base ? decorateRelativeUrlByDomain('/', domains.base) : '/', className: cx('logo', className), ...rest },
        React__default.createElement(Logo$1, { className: cx('logoIcon') })));
};
Logo.displayName = 'Logo';

export { Logo };
//# sourceMappingURL=Logo.js.map
